module.exports = __webpack_public_path__ + "img/Deko Mundo2.52a9b1af.webp";